import { defineComponent as d, computed as u, h as s } from "vue";
import { getModeFromValue as h, convertColor as m } from "./ghl-ui.es902.js";
import { hsva as f, toRgbaString as p } from "./ghl-ui.es892.js";
import { hsv2rgb as w } from "./ghl-ui.es908.js";
import { warn as S } from "./ghl-ui.es841.js";
function y(e, t) {
  if (t === "hsv") {
    const [c, i, l, r] = f(e);
    return p([...w(c, i, l), r]);
  }
  return e;
}
function g(e) {
  const t = document.createElement("canvas").getContext("2d");
  return t ? (t.fillStyle = e, t.fillStyle) : "#000000";
}
const $ = d({
  name: "ColorPickerSwatches",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    swatches: {
      type: Array,
      required: !0
    },
    onUpdateColor: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const t = u(() => e.swatches.map((r) => {
      const o = h(r);
      return {
        value: r,
        mode: o,
        legalValue: y(r, o)
      };
    }));
    function c(r) {
      const {
        mode: o
      } = e;
      let {
        value: n,
        mode: a
      } = r;
      return a || (a = "hex", /^[a-zA-Z]+$/.test(n) ? n = g(n) : (S("color-picker", `color ${n} in swatches is invalid.`), n = "#000000")), a === o ? n : m(n, o, a);
    }
    function i(r) {
      e.onUpdateColor(c(r));
    }
    function l(r, o) {
      r.key === "Enter" && i(o);
    }
    return {
      parsedSwatchesRef: t,
      handleSwatchSelect: i,
      handleSwatchKeyDown: l
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return s("div", {
      class: `${e}-color-picker-swatches`
    }, this.parsedSwatchesRef.map((t) => s("div", {
      class: `${e}-color-picker-swatch`,
      tabindex: 0,
      onClick: () => {
        this.handleSwatchSelect(t);
      },
      onKeydown: (c) => {
        this.handleSwatchKeyDown(c, t);
      }
    }, s("div", {
      class: `${e}-color-picker-swatch__fill`,
      style: {
        background: t.legalValue
      }
    }))));
  }
});
export {
  $ as default
};
